import { AuthAdapterInteface } from 'src/adapter/AuthAdapterInterface';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosAuthAdapter implements AuthAdapterInteface {
  async getTenantIdByClientCode(
    client_code: string
  ): Promise<{ tenant_id: string }> {
    try {
      const res = await api.get('/tenant-id', {
        params: { client_code: client_code },
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getEmailLink(key: string): Promise<{ email_link: string }> {
    try {
      const res = await api.get('/email-link', {
        params: { key: key },
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
